<ifc-browser-warning></ifc-browser-warning>
<router-outlet></router-outlet>